import React from 'react';
import { useLanguage } from '../../store/language-context';
import chain from "../../assets/used-icons/chain.png";
const EventInfoCard = ({ title, description }) => {
    const { language } = useLanguage();
    
    return (
        <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow position-relative border border-[#D9D9D9] relative">
            <div className="size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white " style={{right:'45%'}}>
                                    <span className="text-lg font-bold -secondary-tw">
                                     <img src={chain} />
                                    </span>
                                </div>
            <h3 className={`text-xl font-bold mb-3 text-gray-800 mt-3 ${language === 'ar' ? 'font-arabic' : ''}`}>
                {title}
            </h3>
            <p className={`text-gray-600 ${language === 'ar' ? 'font-arabic' : ''}`}>
                {description}
            </p>
        </div>
    );
};

export default EventInfoCard;
